import React from "react";
interface props {
  className?: string;
}

function BagAboutus({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      className={className}
      fill="none"
      viewBox="0 0 60 60"
    >
      <path
        fill="#5D5FEF"
        d="M54.36 18.968l-3.34 28.125a1.889 1.889 0 01-1.874 1.657H10.858a1.89 1.89 0 01-1.875-1.657l-3.34-28.125a1.875 1.875 0 011.876-2.093H52.48a1.874 1.874 0 011.88 2.093z"
        opacity="0.2"
      ></path>
      <path
        fill="#5D5FEF"
        d="M55.312 16.266A3.783 3.783 0 0052.481 15H41.25a11.25 11.25 0 00-22.5 0H7.519a3.78 3.78 0 00-2.813 1.266 3.75 3.75 0 00-.919 2.925L7.13 47.316a3.75 3.75 0 003.75 3.309h38.262a3.75 3.75 0 003.75-3.31l3.342-28.124a3.751 3.751 0 00-.92-2.925zM30 7.5a7.5 7.5 0 017.5 7.5h-15A7.5 7.5 0 0130 7.5zm19.162 39.375a.03.03 0 01-.02 0H10.84L7.519 18.75h11.23v5.625a1.875 1.875 0 103.75 0V18.75h15v5.625a1.875 1.875 0 103.75 0V18.75H52.5l-3.337 28.125z"
      ></path>
    </svg>
  );
}

export default BagAboutus;
